var swiper = new Swiper(".hero-slider", {
  // autoplay: {
  //   delay: 6500,
  //   disableOnInteraction: false, // This allows autoplay to continue even after user interaction
  // },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// Cart Page Recommdation
var swiper = new Swiper(".cart__collection--box-wrapper", {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
});

// Open Order by phone modal
const div = document.getElementById('modal__content');
const addBtn = document.getElementById('modal__btn');
const removeBtn = document.getElementById('modal-close');

addBtn.addEventListener('click',()=>{
    div.classList.add('open-modal');
    document.querySelector('body').classList.add('overflow-hidden','phoneModal')
})

removeBtn.addEventListener('click',()=>{
    div.classList.remove('open-modal');
    document.querySelector('body').classList.remove('overflow-hidden', 'phoneModal')
})

// Trending Products Tabs
// Define variables
document.addEventListener("DOMContentLoaded", function() {
  let tabLabels = document.querySelectorAll(".product-tab-wrapper .product-tab-list");
  let tabPanes = document.querySelectorAll(".tab-content");

  tabLabels.forEach((label) => {
    label.addEventListener("click", function(e) {
      e.preventDefault();
      // Deactivate all tabs
      tabLabels.forEach((innerLabel) => innerLabel.classList.remove("active"));
      tabPanes.forEach((pane) => pane.classList.remove("active"));

      // Activate clicked tab and corresponding content
      let clickedTab = this.querySelector('a').getAttribute("href").substring(1);
      this.classList.add("active");
      document.getElementById(clickedTab).classList.add("active");
    });
  });
});


// Open Variant Modal
let button = document.querySelectorAll('.open-variant-modal');
let vairnatModal = document.querySelectorAll('.variant-modal');
let closeButton = document.querySelectorAll('.close-svg');
let productForm = document.querySelectorAll('.product-form');

button.forEach((element , index) => {
   element.addEventListener('click', function() {
     console.log('false')
     if(this.parentElement.classList.contains('open-variant-modal')) {
       this.parentElement.classList.remove('open-variant-modal');
     }else{
       this.parentElement.classList.add('open-variant-modal');
       console.log('true')
       button.forEach(l => {                     
          if (l !== this) {                    
              l.parentElement.classList.remove('open-variant-modal'); 
          }                                    
      });
     }      
   });
});

// Click to store and Set Value
let variantLi = document.querySelectorAll('.variant-list');
variantLi.forEach(function(element) {
  element.addEventListener("click", function(){
    let dataValue = this.getAttribute('data-id');
    let siblings = this.parentNode.querySelectorAll('.variant-list');
    siblings.forEach(function(sibling) {
      if (sibling !== element) {
        sibling.classList.remove('active');
      }
    });
    this.classList.add('active');
    let formElement = element.closest('.variant-modal');
    let specificElement = formElement.querySelector('.product-variant-id');
    specificElement.value = dataValue;
  });
});

// Close Variant Modal
closeButton.forEach((element , index) => {
   element.onclick = function () {
     element.closest(".product-form").classList.remove('open-variant-modal');
   }
});


// Free Shipping Progress Bar
fetch('/cart.js')
.then(response => response.json())
.then(cart => {
  var cart_total = parseInt(cart.total_price);
  if (cart_total < 6000) {
    var total = 6000;
    var get_percentage = (((total - cart_total) * 100) / 6000);
    var final_per = (100 - get_percentage);
    var price = (total - cart_total);
    var formattedPrice = '€' + (price / 100).toFixed(2); // Formatting the price in pounds
    document.querySelectorAll('.announcement-bar').forEach(function(parentElement) {
      parentElement.querySelector('.progressbar-progress').style.width = final_per + '%';
      parentElement.querySelector('.announcement-bar__message').style.display = 'block';
      parentElement.querySelector('.progressbar-wrapper').style.display = 'flex';
      parentElement.querySelector('.free-shipping-text').style.display = 'none';
      parentElement.querySelector('.announcement-bar__message .minus-money').innerHTML = formattedPrice;
    });
  } else {
    document.querySelectorAll('.announcement-bar').forEach(function(parentElement) {
      parentElement.querySelector('.announcement-bar__message').style.display = 'none';
      parentElement.querySelector('.progressbar-wrapper').style.display = 'none';
      parentElement.querySelector('.free-shipping-text').style.display = 'block';
    });
  }
});  


// Product Page Tab
// Define variables
var tabLabels = document.querySelectorAll(".tab_list li");
var tabPanes = document.getElementsByClassName("tab__content");

function productTab(e) {
  e.preventDefault();
  
  // Deactivate all tabs
  tabLabels.forEach(function(label, index){
    label.classList.remove("active");
  });
  [].forEach.call(tabPanes, function(pane, index){
    pane.classList.remove("active");
  });
  
  // Activate current tab
  e.target.parentNode.classList.add("active");
  var clickedTab = e.target.getAttribute("href");
  document.querySelector(clickedTab).classList.add("active");
}

// Apply event listeners
tabLabels.forEach(function(label, index){
  label.addEventListener("click", productTab);
});


// Collection Tab Filter
document.querySelectorAll('.collection-tab--wrapper a').forEach(function(tabLink) {
  tabLink.addEventListener('click', function(event) {
    event.preventDefault();
    var tabVal = this.getAttribute('data-tab');
    var pathLocation = window.location.pathname;
    var cusurl = window.location.protocol + '//' + window.location.host + pathLocation + '/' + tabVal;
    document.querySelectorAll('.collection-tab--wrapper a').forEach(function(link) {
      link.classList.remove('active');
    });
    this.classList.add('active');
    var collectionElement = document.getElementById('ProductGridContainer');
    collectionElement.classList.add('cus-loading');
    var xhr = new XMLHttpRequest();
    xhr.open('GET', cusurl, true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = xhr.responseText;
          var newdata = tempDiv.querySelector('#ProductGridContainer').innerHTML;
          collectionElement.innerHTML = newdata;
          collectionElement.classList.remove('cus-loading');
        } else {
          collectionElement.classList.remove('cus-loading');
        }
      }
    };
    xhr.send();
  });
});